export const SEARCH_TEST_IDS = {
  INPUT_CONTAINER: 'search-input-container',
  INPUT: 'search-input',
  PAGE_INPUT: 'search-page-input',

  SUGGESTIONS_DROPDOWN: 'search-suggestions-dropdown',
  SUGGESTIONS_TEMPLATE_GROUP: 'search-suggestions-template-group',
  SUGGESTIONS_TEMPLATE_ITEM: 'search-suggestions-template-item',
  SUGGESTIONS_EMPTY: 'search-suggestions-empty',

  HEADER: 'search-header',
  HEADER_TITLE: 'search-header-title',
  HEADER_SUBTITLE: 'search-header-subtitle',

  RESULTS_SECTION: 'search-results-section',
  RESULTS_GRID: 'search-results-grid',
  RESULTS_ITEM: 'search-results-item',

  STATUS_MESSAGE: 'search-status-message',
} as const;
